import React, { useState, useEffect } from "react";
import { withRedux } from "helpers";
import { DragDropContext } from "react-beautiful-dnd";
import Column from "../../EditApp/TemplateOrdering/Column";
import DoneIcon from "@material-ui/icons/Done";
import { Button } from "appStyles";
import { getSortedDataToDisplay } from "helpers";

function SelectionItemOrdering({
  items,
  actions: { updateSelectionItemRanks },
  actions,
  closeItemsModal,
  updateGroup,
  storeItemId,
  getGroup,
  groups,
  accessToken,
  ...props
}) {
  // console.log("Reorder Selection Modal items:");
  // console.dir(items);
  const store = [];

  const group = getGroup();

  const data = getSortedDataToDisplay(items);

  // console.dir(data);

  data.reverse().forEach((item) => {
    if (!item.retired) {
      store.push(item);
    }
  });

  // console.dir(store);

  let nullRankFlag = false;
  // go through all groups and add their title to array based on order recieved
  // const displayItems = getSortedDataToDisplay(store);
  const displayItems = [];
  store.map((item) => {
    if (item.sortOrder && !item.retired) {
      return (displayItems[item.sortOrder - 1] = {
        id: item.id,
        title: item.name,
        sortOrder: item.sortOrder,
      });
    } else {
      nullRankFlag = true;
    }
  });

  if (nullRankFlag) {
    store.reverse().map((item) => {
      if (!item.sortOrder && !item.retired) {
        return displayItems.push({
          id: item.id,
          title: item.name,
          sortOrder: item.sortOrder,
        });
      }
    });
  }

  // console.dir(displayItems);

  const [storeMap, setStoreMap] = useState({});
  const [column, setColumn] = useState({
    id: "column",
    title: "Reorder Items",
    rowItemIds: [], // hold all items
  });
  const [canClick, setCanClick] = useState(false);

  useEffect(() => {
    const storeMapTemp = {}; // create a hashmap
    const rowItemIds = displayItems.map((n) => n.id).filter((n) => n); // return a new array with ids only

    displayItems.forEach((item) => {
      // for each navigation component
      storeMapTemp[item.id] = {
        // set key to the id, and value to an object that has id and title
        id: item.id,
        content: item.title,
      };
    });

    setColumn({
      ...column,
      rowItemIds,
    });

    setStoreMap(storeMapTemp);
  }, column);

  // drag drop logic
  const onDragEnd = (result) => {
    const { destination, source, draggableId } = result;

    if (!destination) return;
    if (
      destination.droppableId === source.draggableId ||
      destination.index === source.index
    )
      return;

    const newRowItemIds = [...column.rowItemIds];
    newRowItemIds.splice(source.index, 1);
    newRowItemIds.splice(destination.index, 0, draggableId);

    const newColumn = {
      ...column,
      rowItemIds: newRowItemIds,
    };

    setColumn(newColumn);
    setCanClick(true);
  };

  const updateItems = (items) => {
    // console.log("updating group with new ranks");
    // console.dir(group);
    updateGroup({ ...group, additionalOptionsItems: items });

    // updateGroups(group);
  };

  const updateRanks = async () => {
    const apiBody = {};
    let result = null;
    // console.log("updating selection item ranks");
    // console.dir(group);

    const isNewGroup =
      (typeof group.id === "string" && group.id.toString().length === 20) ||
      group.id === "NewGroup";

    store.forEach((item) => {
      const sortOrder = column.rowItemIds.indexOf(item.id) + 1;
      // console.log("setting " + item.name + " to order " + sortOrder);

      if (isNewGroup) {
        // console.log("updating ranks for a new group");
        item.sortOrder = sortOrder;
        result = store;
      } else {
        // console.log("updating ranks for existing group");
        const id = item.id;
        apiBody[id] = sortOrder;
      }
    });
    // console.dir(apiBody);
    // console.dir(result);

    if (!isNewGroup) {
      // console.log("updating ranks for existing group");
      // console.dir(apiBody);
      result = await updateSelectionItemRanks(apiBody, group.id, accessToken);
    }

    updateItems(result);

    setCanClick(false);
    closeItemsModal();
  };

  const rowItems = column.rowItemIds.map((id) => {
    if (id != undefined) return storeMap[id];
  });

  return (
    <div>
      <DragDropContext onDragEnd={onDragEnd}>
        <Column key={column.id} column={column} rowItems={rowItems} />
      </DragDropContext>
      <div
        style={{ display: "flex", justifyContent: "center", marginTop: "5px" }}
      >
        <Button
          onClick={() => updateRanks()}
          disabled={!canClick}
          style={{
            margin: "0px",
            display: "inline-flex",
            alignItems: "center",
            textAlign: "center",
            fontSize: "15px",
            lineHeight: "29px",
            borderRadius: "5.5px",
            backgroundColor: canClick ? "#89d2d3" : "#adadad",
            fontWeight: "bold",
            boxShadow: "3px 3px 13px rgba(120, 120, 120, 0.5)",
            fontStyle: "normal",
            fontStretch: "normal",
            textTransform: "none",
            marginTop: "10px",
          }}
        >
          <DoneIcon style={{ marginRight: "5px" }}></DoneIcon>
          Update Item Order
        </Button>
      </div>
    </div>
  );
}

export default withRedux(SelectionItemOrdering);
